<template>
    <div class="wrap">
        <!-- 顶部栏目 -->
        <div class="bar flex-between">
            <div class="icon_wrap">
                <img src="../../assets/img/logo.png" alt="" />
            </div>
            <div class="bar_name">经济与管理学院虚拟仿真实验教学中心-金融交易虚拟仿真实验系统</div>
            <div class="bar_right">
                <a href="javascript:void(0)" @click="memberDialog = true">虚仿教师团队成员信息</a>
            </div>
        </div>
        <!-- 标题+实验入口 -->
        <div class="content">
            <div class="content_title">
                <div>欢迎使用</div>
                <div>期货、期权交易虚拟仿真实验</div>
            </div>
            <div class="content_button">
                <a @click="disclaimerVisble = true">
                    <div>虚仿实验端（学生入口）</div>
                </a>
                <a @click="selectIdentity(14)">
                    <div>虚仿管理端（教师入口）</div>
                </a>
                <a @click="authVisible = true">
                    <div style="background: #cd3e6a">评审专家通道</div>
                </a>
            </div>
            <div class="content_footer">
                <!-- <div>建议使用谷歌浏览器进行实验( <a style="text-decoration:underline;color:#71B8EE" href="https://mssdk-docs.obs.cn-southwest-2.myhuaweicloud.com/kd_excle_import_mode/ChromeSetup.exe">浏览器下载地址</a> )</div> -->
                <div>
                    用户须知：
                    <span class="mouse-hover" style="color: #71b8ee" @click="declareVisible = true">《知识产权申明》</span>
                    <span class="mouse-hover" style="color: #71b8ee" @click="loginVisble = true">《系统登录说明》</span>
                </div>
                <div>热线电话：028-61831033 &nbsp;&nbsp;&nbsp;&nbsp;虚拟实验服务和支持QQ群：459797943&nbsp;&nbsp;&nbsp;</div>
            </div>
        </div>
        <!-- 访问人数 -->
        <div class="count_wrap">
            <div class="count_title">访问统计</div>
            <div>
                <div class="count_current">今日访问量：&nbsp;{{ proAccessNum.currentNum }}</div>
                <div class="count_history">历史访问：&nbsp;{{ proAccessNum.historyNUm }}</div>
                <!-- <div class="count_people">实验人数：&nbsp;{{proAccessNum.testNum}}</div> -->
            </div>
        </div>
        <el-dialog title="访问方式" :visible.sync="visiteShow" top="11%" :modal-append-to-body="false" center>
            <div class="flex visitor_wrap">
                <div v-for="school in schools" class="visitor_item" @click="school.id === 1 ? userAuth() : toLogin()">
                    <img :src="school.url" alt="#" />
                    <div>{{ school.name }}</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="专家认证" :visible.sync="authVisible" width="25%" top="12%" :modal-append-to-body="false" center>
            <div class="align_center">
                <div>认证码：</div>
                <div style="width: 60%">
                    <el-input @keyup.enter.native="toExpert()" type="password" v-model="authCode" placeholder="请输入专家认证码"></el-input>
                </div>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="toExpert">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="知识产权申明" :visible.sync="declareVisible" :modal-append-to-body="false" center>
            <div class="dialog_wrap">
                <p>
                    明显归属于第三方所有的信息资料外，电子科技大学拥有本网站所载的所有材料或内容，包括但不限于文字、图片、图形、表格、动画、程序、软件等单独或组合的版权。
                </p>
                <p>任何被授权的浏览、复制、打印和传播属于本网站内的资料必须符合以下条件：</p>
                <p>所有的资料和图象均以获得信息为目的；</p>
                <p>所有的资料和图象均不得用于商业目的；</p>
                <p>所有的资料、图像及其任何部分都必须包括此版权声明；</p>
                <p>
                    本网站上使用和显示的“电子科技大学”及相关图形、标识等为电子科技大学的注册商标。未经电子科技大学事先书面许可，任何人不得擅自使用电子科技大学的任何知识产权，包括但不限于以非法的方式复制、传播、展示、镜像、上载、下载，或通过非常规方式（如：恶意干预网站数据）影响本网站的正常服务，任何人不得擅自以软件程序自动获得本网站数据。否则，电子科技大学将依法追究其法律责任。
                </p>
                <p>
                    本网站著作权归电子科技大学所有。商业转载请联系作者获得授权，非商业转载请注明出处。您有任何疑问或建议，可以通过服务支持邮箱jgsyzx@uestc.edu.cn联系我们。
                </p>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="declareVisible = false">我已知晓</el-button>
            </div>
        </el-dialog>
        <el-dialog title="系统登录说明" :visible.sync="loginVisble" :modal-append-to-body="false" center>
            <div class="dialog_wrap">
                <p>本实验项目推荐使用Chrome浏览器、火狐浏览器、QQ浏览器或其他可使用Chrome内核的浏览器进行访问，共有三种登录途径：</p>
                <p>
                    方式1：由实验空间网站
                    <a href="https://www.ilab-x.com/details/page?id=3700&isView=true" target="_blank" rel="noopener noreferrer"
                        >https://www.ilab-x.com/details/page?id=3700&isView=true</a
                    >
                    跳转登陆时，会自动获取实验空间用户名，用户可直接点击登陆开始实验；
                </p>
                <p>
                    方式2：由实验项目地址
                    <a href="https://vlab.uestc.edu.cn/finance/#/login" target="_blank" rel="noopener noreferrer"
                        >https://vlab.uestc.edu.cn/finance/#/login</a
                    >
                    直接访问时，学生用老师开通的账号密码登录使用，如未加入班级可通过方式1进入；
                </p>
                <p>方式3：专家评审登陆时，默认用户名为电子科技大学，输入认证码可开始实验。</p>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="loginVisble = false">我已知晓</el-button>
            </div>
        </el-dialog>
        <el-dialog title="免责申明" :visible.sync="disclaimerVisble" :modal-append-to-body="false" center>
            <div class="dialog_wrap">
                <p>
                    在继续浏览本网站前，请您仔细阅读本重要提示，并点击"确认"或"放弃"键，根据您的具体情况选择继续浏览还是放弃。点击"确认"键，视为您已经阅读并愿意遵守本提示内容。
                </p>
                <p>
                    本实验倡导健康文明的实验环境，禁止传播违法、低俗、暴力、造谣等不良信息。擅自在网络上发布不当言论者根据国家法律必须承担相应的责任。实验内容不构成投资建议，市场有风险，投资需谨慎。
                </p>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="(disclaimerVisble = false), selectIdentity(4)">确定</el-button>
                <el-button class="ml20" @click="disclaimerVisble = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="期货、期权交易虚拟仿真实验教师队伍简介" :visible.sync="memberDialog" :modal-append-to-body="false" center>
            <div class="member-wrap">
                <div v-for="member in members">
                    <img :src="member.url" alt="" />
                    <div class="member-info">
                        <div>{{ member.name }}</div>
                        <div>{{ member.position }}</div>
                        <div>{{ member.intro }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import { Loading } from 'element-ui';

export default {
    data() {
        return {
            disclaimerVisble: false,
            declareVisible: false,
            memberDialog: false,
            loginVisble: false,
            responseUrl: '',
            authVisible: false,
            authCode: '',
            visiteShow: false,
            proAccessNum: {
                currentNum: '',
                historyNum: '',
                testNum: ''
            },
            userId: '',
            studentId: '',
            schoolId: '',
            loadIns: null,
            loginId: '',
            members: [
                {
                    url: require('@/assets/img/member/liping.jpg'),
                    name: '李平',
                    position: '教授、博导、虚仿项目负责人',
                    intro: '《综合课程设计：量化交易与商业银行》课程主讲教师'
                },
                {
                    url: require('@/assets/img/member/xiahui.jpg'),
                    name: '夏晖',
                    position: '教授',
                    intro: '金融交易策略设计与模拟》课程主讲教师，国家级一流线上课程《风险投资与创业融资》主讲教师'
                },
                {
                    url: require('@/assets/img/member/chenlei.jpg'),
                    name: '陈磊',
                    position: '副教授',
                    intro: '《金融交易策略设计与模拟》课程主讲教师，国家级一流线上课程《计量经济学》主讲教师'
                },
                {
                    url: require('@/assets/img/member/kongxiaoli.jpg'),
                    name: '孔晓李',
                    position: '实验师',
                    intro: '《证券投资模拟实验》课程主讲教师'
                },
                {
                    url: require('@/assets/img/member/chenlin.jpg'),
                    name: '陈林',
                    position: '副教授',
                    intro: '综合课程设计：量化交易与商业银行》课程主讲教师'
                },
                {
                    url: require('@/assets/img/member/yinyuming.jpg'),
                    name: '尹宇明',
                    position: '副教授',
                    intro: '国家级一流线上课程《风险投资与创业融资》主讲教师'
                },
                {
                    url: require('@/assets/img/member/yangzheng.jpg'),
                    name: '杨政',
                    position: '副教授',
                    intro: '国家级一流线上课程《计量经济学》主讲教师'
                }
            ],
            schools: [
                {
                    url: require('@/assets/img/school/kdlogo.png'),
                    name: '电子科技大学',
                    id: 1
                },
                {
                    url: require('@/assets/img/school/cuit.png'),
                    name: '成都信息工程大学',
                    id: 2
                },
                {
                    url: require('@/assets/img/school/sau.png'),
                    name: '四川农业大学',
                    id: 3
                },
                {
                    url: require('@/assets/img/school/xcc.jpg'),
                    name: '西昌学院',
                    id: 4
                },
                {
                    url: require('@/assets/img/school/njtc.png'),
                    name: '内江师范学院',
                    id: 5
                },
                {
                    url: require('@/assets/img/school/nxcy.png'),
                    name: '宁夏财经职业技术学院',
                    id: 6
                },
                {
                    url: require('@/assets/img/school/ccst.png'),
                    name: '重庆大学城市科技学院',
                    id: 7
                },
                {
                    url: require('@/assets/img/school/ncepu.png'),
                    name: '华北电力大学',
                    id: 8
                },
                {
                    url: require('@/assets/img/school/xsh.png'),
                    name: '广西民族大学相思湖学院',
                    id: 9
                },
                {
                    url: require('@/assets/img/school/sdslzyxy.png'),
                    name: '山东水利职业学院',
                    id: 10
                },
                {
                    url: require('@/assets/img/school/cdjcxy.png'),
                    name: '成都锦城学院',
                    id: 11
                },
                {
                    url: require('@/assets/img/school/mycs.jpg'),
                    name: '绵阳城市学院',
                    id: 12
                },
                {
                    url: require('@/assets/img/school/other.png'),
                    name: '其他学校',
                    id: 99
                }
            ]
        };
    },
    created() {
        this.accessNum();
    },
    methods: {
        selectIdentity(val) {
            this.visiteShow = true;
            this.loginId = val;
        },

        //校内人员认证
        userAuth() {
            location.href = `${this.$config.baseUrl}/liuwanr/userInfo/loginSchoolPerson?roleId=${this.loginId}`;
        },

        accessNum() {
            this.$store.replaceState({});
            sessionStorage.clear();
            this.$get(this.api.getAccessNum)
                .then((res) => {
                    (this.proAccessNum.currentNum = res.currentNum),
                        (this.proAccessNum.historyNUm = res.historyNUm),
                        (this.proAccessNum.testNum = res.experimentNum);
                })
                .catch((err) => {});
            if (this.$route.query.ticket) {
                this.$get(`${this.api.ticket}?ticket=${this.$route.query.ticket}`)
                    .then((res) => {
                        location.href = res.message;
                    })
                    .catch((err) => {});
            }
        },
        toLogin() {
            //4是学生端，14是教师端，24是专家
            if (this.loginId == 4) {
                location.href = `${this.$config.baseUrl}/kdclient/#/clientLogin?type=0&roleId=${this.loginId}`;
                this.visiteShow = false;
            } else {
                let url = `${this.$config.baseUrl}/kdserver/#/login?type=0`;
                window.open(url, '_blank');
                this.visiteShow = false;
            }
        },
        async toExpert() {
            const loginInfo = await this.$get(this.api.loginProfessor, { code: this.authCode });
            if (loginInfo.status !== 200) {
                return this.$message.error('认证码错误！！');
            }

            this.loadIns = Loading.service({
                background: 'rgba(255,255,255,.6)'
            });

            this.$store.commit('expertLogin', {
                isExpertLogin: true
            });

            this.schoolList = [...loginInfo.message.staffList, ...loginInfo.message.studentList];
            let indexs = {};
            this.schoolList = this.schoolList.reduce((cur, next) => {
                indexs[next.schoolId] ? '' : (indexs[next.schoolId] = true && cur.push(next));
                return cur;
            }, []);
            if (this.schoolList.length >= 1) {
                this.schoolId = this.schoolList[0].schoolId;
                this.userId = this.schoolList[0].userId;
                this.studentId = this.schoolList[0].studentId;
                this.roleId = 4;
                this.$store.commit('tokenData', { loginToken: loginInfo.message.loginToken });
                let data = {
                    roleId: 4,
                    userId: this.userId,
                    schoolId: this.schoolId
                };
                this.$get(this.api.logins, data)
                    .then((res) => {
                        sessionStorage.setItem('kd_client_username', res.message.user.account);
                        this.$store.commit('userLoginData', {
                            userId: this.userId,
                            accountRole: this.roleId,
                            studentId: this.studentId,
                            schoolId: this.schoolId,
                            token: res.message.user.token
                        });
                        res.message.user.userAvatars && this.$store.commit('userPhoto', { avatar: res.message.user.userAvatars });
                        this.$store.commit('userName', { userName: res.message.user.userName });
                        this.$store.commit('dataTime', { dataTime: res.message.user.dataTime });
                        sessionStorage.setItem('isTeacher', true);
                        this.loadIns.close();
                        this.$router.replace('/dashboard');
                        //专家登录，清除实验缓存，请求头内包含userId,token,isChallenge
                        axios({
                            url: this.api.commitReport,
                            method: 'post',
                            headers: {
                                userId: this.userId,
                                token: res.message.user.token,
                                isChallenge: 0
                            }
                        });
                        axios({
                            url: this.api.commitReport,
                            method: 'post',
                            headers: {
                                userId: this.userId,
                                token: res.message.user.token,
                                isChallenge: 1
                            }
                        });
                        axios({
                            url: this.api.commitReport,
                            method: 'post',
                            headers: {
                                userId: this.userId,
                                token: res.message.user.token,
                                isChallenge: 2
                            }
                        });
                    })
                    .catch(() => {
                        this.loadIns.close();
                    });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.mouse-hover:hover {
    cursor: pointer !important;
    opacity: 0.85;
}

/deep/ .el-dialog__title {
    font-size: 25px;
    font-weight: bold;
}

.dialog_wrap {
    padding: 0 30px;
    font-size: 18px;
    line-height: 1.7;
    text-indent: 2rem;
    text-align: justify;
}

.align_center {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}

.visitor_wrap {
    flex-wrap: wrap;
    row-gap: 30px;
    justify-content: flex-start;

    .visitor_item {
        width: 20%;
        text-align: center;
        font-size: 16px;

        img {
            width: 96px;
            height: 96px;
            object-fit: contain;
            margin-bottom: 8px;
            border-radius: 50%;
            box-shadow: -2px 2px 2px #656b6f;
            background: #fff;
        }
    }

    .visitor_item:hover {
        opacity: 0.8;
        cursor: pointer;
        color: #2d68f2;
    }
}

.wrap {
    font-family: '微软雅黑';
    width: 100%;
    height: 100%;
    position: fixed;
    background: url('../../assets/img/bg.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .bar {
        width: 100%;
        height: 90px;
        background: #004592;
        border-bottom: 2px solid #4d8ab6;
        box-shadow: -3px 7px 5px -7px rgba(77, 70, 70, 0.75);
        -webkit-box-shadow: -3px 7px 5px -7px rgba(77, 70, 70, 0.75);
        -moz-box-shadow: -3px 7px 5px -7px rgba(77, 70, 70, 0.75);

        .icon_wrap {
            width: 12%;
            height: 90px;
            background: #cd3e6a;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                height: 45px;
            }
        }

        .bar_name {
            width: 88%;
            box-sizing: border-box;
            padding-left: 100px;
            font-size: 25px;
            color: white;
        }

        .bar_right {
            float: right;
            font-size: 20px;
            color: white;
            text-decoration: underline;
            // 不换行
            white-space: nowrap;
            margin-right: 40px;
        }
    }

    .content {
        .content_title {
            height: 400px;
            width: 100%;
            text-align: center;
            box-sizing: border-box;
            padding: 100px 0px;
            line-height: 100px;
            font-size: 60px;
            color: white;
            letter-spacing: 8px;
            // background: red;
        }

        .content_button {
            height: 280px;
            //    background: blue;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-flow: column;

            div {
                width: 400px;
                height: 70px;
                text-align: center;
                line-height: 70px;
                font-size: 28px;
                color: white;
                //    background: green;
                background: url('../../assets/img/button.png');
                background-size: 400px 70px;
            }

            div:hover {
                background: #ff5288;
                border: 2px solid white;
                cursor: pointer;
            }
        }

        .content_footer {
            margin-top: 50px;
            height: 200px;
            width: 100%;
            text-align: center;
            color: white;
            font-size: 28px;
            line-height: 50px;
            font-family: '仿宋';

            .icon-dianhuahaoma,
            .icon-a317 {
                font-size: 32px;
                margin-right: 10px;
            }
        }
    }
}

.count_wrap {
    position: fixed;
    bottom: 0px;
    width: 230px;
    height: 200px;
    left: 130px;
    color: white;

    .count_title {
        font-size: 30px;
        margin-bottom: 25px;
        font-weight: 540;
    }

    div {
        font-size: 20px;
        margin-bottom: 13px;
        letter-spacing: 2px;
        font-weight: 50;
    }
}

.member-wrap {
    display: grid;
    // 需要布置成两列
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    padding: 10px 40px;
    height: 700px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 4px; /* 或者height: 10px，根据需要修改 */
        background-color: #f1f1f1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(85, 85, 85, 0.5);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(85, 85, 85, 0.7);
    }

    > div {
        font-size: 23px;
        margin-bottom: 5px;
        display: flex;

        img {
            width: 150px;
        }

        .member-info {
            width: 100%;
            // 添加边框虚线
            border: 1px dashed #cecece;
            border-radius: 5px;
            margin-left: 16px;
            padding: 10px 0 0 10px;

            div {
                &:nth-child(1) {
                    font-weight: bold;
                    font-size: 20px;
                }

                color: black;
                font-size: 16px;
                margin-bottom: 20px;
            }
        }

        &:first-of-type {
            grid-column: span 2 / span 2;
        }
    }
}
</style>
